import type { FunctionComponent } from 'react';

import { Spinner } from 'flowbite-react';

export type SpinnerProps = {
  color?: 'primary' | 'secondary' | 'default' | 'dark';
  sizing?: 'small' | 'medium' | 'large';
};

const customTheme = {
  base: 'inline animate-spin text-gray-200',
  color: {
    primary: 'fill-brand',
    secondary: 'fill-accent',
    dark: 'fill-dark',
    default: 'fill-n400_input_stroker'
  },
  light: {
    off: {
      base: 'dark:text-gray-600',
      color: {
        failure: '',
        gray: 'dark:fill-gray-300',
        info: '',
        pink: '',
        purple: '',
        success: '',
        warning: ''
      }
    },
    on: {
      base: '',
      color: {
        failure: '',
        gray: '',
        info: '',
        pink: '',
        purple: '',
        success: '',
        warning: ''
      }
    }
  },
  size: {
    xs: 'h-3 w-3',
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
    xl: 'h-10 w-10'
  }
};

const sizesVariants = {
  small: 'sm',
  medium: 'md',
  large: 'lg'
};

const colors = {
  primary: 'fill-brand',
  secondary: 'fill-accent',
  dark: 'fill-dark',
  default: 'fill-n400_input_stroker'
};

export const LoadingIndicator: FunctionComponent<SpinnerProps> = ({ color = 'primary', sizing = 'medium' }) => {
  return <Spinner size={sizesVariants[sizing]} theme={customTheme} className={`${colors[color]}`} />;
};
